module.exports = __webpack_public_path__ + "assets/img/icon_logout.aa269906.svg";